import BaseModel from './BaseModel';

/** Class representing an user. */
class PaymentSystem extends BaseModel {}

PaymentSystem.PAYMENT_SYSTEM_NET_OXYGEN    = 'Net Oxygen Sàrl (Ecom)';
PaymentSystem.PAYMENT_SYSTEM_DATATRANS     = 'Datatrans (Ecom)';
PaymentSystem.PAYMENT_SYSTEM_SUMUP_ONLINE  = 'Sumup (Ecom)';
PaymentSystem.PAYMENT_SYSTEM_SUMUP         = 'Sumup (Face2Face)';
PaymentSystem.PAYMENT_SYSTEM_TWINT         = 'Twint (Face2Face)';
PaymentSystem.PAYMENT_SYSTEM_WALLEE_ONLINE = 'Wallee (Ecom)';
PaymentSystem.PAYMENT_SYSTEM_WALLEE        = 'Wallee (Face2Face)';
PaymentSystem.PAYMENT_SYSTEM_STRIPE_ONLINE = 'Stripe (Ecom)';

/**
 * Get the fields to get server side when we
 * ask for a payment systems listing
 */
PaymentSystem.getListingFields = () => [
    'id',
    'name'
];

export default PaymentSystem;
